module.exports = require("./dist/angular-filter.js");


//////////////////
// WEBPACK FOOTER
// angular-filter (bower component)
// module id = 422
// module chunks = 0